export default __webpack_public_path__ + "static/media/Avatar-13-noback.757b602d.png";